import DeepLink from "../../components/DeepLink";
import VerticalPlayer from "../../components/VerticalPlayer";
import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useAppRouteContext } from "../context/AppRouteContext";

const FeedEntryRoute = () => {
  const location = useLocation();
  const { selectedFeedTemplateType, selectedSdkTemplateType } =
    useAppRouteContext();

  const deepLinkId = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get("id");
  }, [location.search]);

  if (deepLinkId) {
    return <DeepLink />;
  }

  if (selectedSdkTemplateType === "DISCOVER") {
    return <VerticalPlayer templateTypes={["VERTICAL_VIDEO", "POST"]} />;
  }

  return <VerticalPlayer templateType={selectedFeedTemplateType} />;
};

export default FeedEntryRoute;
